/*
 * This work has been created or enhanced by
 *   Markus Luckey, 2025, KERNBLICK GmbH
 *
 * This file is covered by the EU PL 1.2 license.
 * You may obtain a copy of the licence at
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 */

import { createApp } from 'vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import i18n from './i18n';
import App from './App.vue';
import router from './router';

import {createBootstrap} from 'bootstrap-vue-next'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { fas } from '@fortawesome/free-solid-svg-icons';

/* add icons to the library */
library.add(fas)

const app = createApp(App)

app
  .component('FontAwesomeIcon', FontAwesomeIcon)
  .use(router)
  .use(i18n)
  .use(createBootstrap())
  .mount('#app');
